import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import reducers from './reducers';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';

export default function createAppStore(initState) {
  let middlewares = [promise(), thunk];
  if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
    const loggerMiddleware = logger();
    middlewares.push(loggerMiddleware);
  }
  const middleware = applyMiddleware(...middlewares);

  // Adds redux devtools support
  // https://github.com/zalmoxisus/redux-devtools-extension#usage
  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  return createStore(
    combineReducers(reducers),
    initState,
    composeEnhancers(middleware)
  );
}
